/**
 * Renders one value as a CSV field, per RFC 4180.
 *
 * `react-csv-downloader` joins fields with the separator and escapes nothing -- its
 * `wrapColumnChar` option wraps values verbatim without doubling embedded quotes -- so anything
 * containing a comma, a quote, or a line break has to arrive already escaped or it splits the row
 * into the wrong columns. Values are only quoted when they need it, so numbers and ordinary names
 * stay bare and spreadsheets keep reading them as numbers.
 */
// eslint-disable-next-line import/prefer-default-export
export const toCsvField = (value?: string | number | null) => {
  if (value === null || value === undefined) return '';
  const text = String(value);
  if (!/[",\r\n]/.test(text)) return text;
  return `"${text.replace(/"/g, '""')}"`;
};
